export const buttonStyle: any = {
    green: {
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        ':hover': {
            backgroundColor: 'primary.dark',
        }
    },
    blue: {
        backgroundColor: 'secondary.main',
        color: 'secondary.contrastText',
        ':hover': {
            backgroundColor: 'secondary.dark'
        }
    },
    yellow: {
        backgroundColor: 'tertiary.main',
        color: 'tertiary.contrastText',
        ':hover': {
            backgroundColor: 'tertiary.dark',
        }
    },
    white: {
            backgroundColor: 'white',
            color: 'var(--primary-text)',
            ':hover': {
                backgroundColor: '#D3D3D3',
            }
        }
}
